import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const solid = scrolled || !isHome || menuOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <span
              className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg transition-colors ${
                solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
              }`}
            >
              <i className="ri-water-flash-line" />
            </span>
            <span className="leading-none">
              <span
                className={`block font-heading font-black text-lg tracking-tight ${
                  solid ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                911吃瓜
              </span>
              <span
                className={`block text-[10px] tracking-[0.2em] mt-0.5 ${
                  solid ? 'text-foreground-500' : 'text-background-100/80'
                }`}
              >
                关系图 · 回应 · 链条
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? solid
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-background-50/20 text-background-50'
                      : solid
                        ? 'text-foreground-700 hover:bg-background-100'
                        : 'text-background-50/90 hover:bg-background-50/15'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/cases"
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-line" />
              今日热瓜
            </Link>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 rounded-md flex items-center justify-center text-xl cursor-pointer transition-colors ${
                solid ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/15'
              }`}
            >
              <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}